import { ChatListItem } from '~/components/Chat/types';
import { ClaimItemBase } from '~/components/Claim/types';
import ChatIcon from '~/core/iconComponents/icons/ChatIcon';
import { parseDateWithOptionalTimezone, toTimeAgo } from '~/utils/Dates/DateTimeUtils';

export const chatToClaimItem = (chat: ChatListItem): ClaimItemBase => ({
  id: chat.chat_id,
  type: 'chat',
  claim_number: chat.claim_number,
  title: chat.chat_title,
  content: '',
  created_at: chat.created_at,
  updated_at: chat.updated_at,
  metadata: chat.chat_metadata,
});

export const ChatToListItem = (chat: ClaimItemBase) => {
  const timeAgo = chat.updated_at ? toTimeAgo(parseDateWithOptionalTimezone(chat.updated_at)) : '';

  return {
    id: chat.id,
    content: (
      <div className="flex w-full items-center pr-8">
        <div>{chat.title}</div>
        <span className="ml-auto text-sm font-normal text-blue-950">{timeAgo}</span>
      </div>
    ),
    icon: (
      <div className="flex items-center justify-center rounded-lg bg-blue-100 p-4">
        <ChatIcon size={16} className="shrink-0 text-blue-600" />
      </div>
    ),
    data: chat,
  };
};
